import React from 'react'
import { Channel } from '@ztechapps/chat.webui'

import { useChatMessageContext } from './Context'

export const ChatContainer = () => {
  const { conversationId, sendChatMessageResult } = useChatMessageContext()

  return <Channel conversationId={conversationId} hideFormalizeButton sendChatMessageResult={sendChatMessageResult} />
}
